// Runtime auth config (EW-242, the admin FE's EW-166 pattern): deployed
// environments serve GET /config.json from the gateway itself (frontend_config.py,
// values from the container's ECHOPROXY_* env vars) so one neutral image works
// everywhere. Local dev has no /config.json — the Vite dev server answers it with
// its HTML fallback, `res.json()` throws, and callers fall back to the Vite-baked
// VITE_* values.
//
// EW-66: the authority is runtime too. `authorityUrl` set = a generic OIDC issuer
// (e.g. the local Keycloak mock realm); empty = the Entra authority is derived
// from `entraTenantId`. The key names intentionally match the admin FE's
// RuntimeConfig — the two SPAs speak the same contract.
export interface RuntimeConfig {
  entraTenantId?: string;
  adminClientId?: string;
  authorityUrl?: string;
}

export async function fetchRuntimeConfig(): Promise<RuntimeConfig | null> {
  try {
    // The timeout is a deliberate divergence from the admin FE mirror: there
    // /config.json is a static file off nginx, here the same FastAPI process
    // serves it — and main.tsx awaits this before the first render, so a
    // hanging socket would otherwise be a permanent blank page.
    const res = await fetch('/config.json', {
      cache: 'no-store',
      signal: AbortSignal.timeout(5000),
    });
    if (!res.ok) return null;
    return (await res.json()) as RuntimeConfig;
  } catch {
    return null;
  }
}
